export const LUCKY_DRAW_CLICKED_REGISTER = 'Lucky draw - Clicked Register';
export const LUCKY_DRAW_CLICKED_LUCKY_DRAW = 'Lucky draw - Clicked Lucky Draw';
export const LUCKY_DRAW_CLICKED_CTA = 'Lucky draw - Clicked CTA';
